export default "__VITE_ASSET__koo3tM9x__"